import { Edit } from '@mui/icons-material';
import { Card, CardContent, CardHeader, IconButton } from '@mui/material';
import { FC, useCallback } from 'react';
import { EditButton, Loading, TextField, useShowController } from 'react-admin';
import { useNavigate } from 'react-router-dom';

export const TrendShow: FC = () => {
  const data = useShowController();
  const navigate = useNavigate();
  const { record, isLoading, isFetching } = data;

  const handleClickEdit = useCallback(() => {
    navigate(`/digests/${record.id}`);
  }, [record.id, navigate]);

  if (isLoading || isFetching) {
    return <Loading />;
  }
  return (
    <Card>
      <CardHeader
        title={`${record.name}`}
        subheader={record.avtor.name}
        action={
          <IconButton aria-label="Edit" onClick={handleClickEdit}>
            <Edit />
          </IconButton>
        }
      />
      <CardContent>
        <TextField source="name" record={data.record} />
        <EditButton label="Редактировать" />
      </CardContent>
    </Card>
  );
};
